import React, { Fragment } from "react";

import { MenuItem } from "@/components/MobileLayout/Menu/MenuItem";
import { useStoredDataDispatch } from "@/store";
import { useAuthenticateConnectedUser, useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { SupButton, SupChip, SupLoader, SupText } from "@repo/core-ui";
import { SupCheckCircle, SupLock, SupWallet, SupWalletDisconnect } from "@repo/core-ui";

export default function MobileLayoutMenuWallet() {
  const storedDispatch = useStoredDataDispatch();

  const { authenticateUser, isAuthenticating } = useAuthenticateConnectedUser();
  const { primaryWallet, user, handleLogOut, setShowDynamicUserProfile } = useDynamicContext();

  const handleClose = () => {
    storedDispatch({ type: "closeOverlay" });
  };

  const disconnectWallet = async () => {
    await handleLogOut();
  };

  return (
    <nav className="flex flex-col pt-6">
      {primaryWallet && (
        <Fragment>
          <div className="flex justify-between px-4">
            <div className="relative flex flex-col">
              <SupText variant="subtitle1" weight="bold" className="tracking-[1px]">
                Wallet
              </SupText>
              <SupButton
                variant="outlined"
                className="-ml-1 h-8 border-none px-0 hover:bg-primary-200/20"
                prefixIcon={<SupWallet className="h-4 w-4" />}
                onClick={() => {
                  handleClose();
                  setShowDynamicUserProfile(true);
                }}
              >
                {primaryWallet && (
                  <SupText variant="caption" className="normal-case">
                    {primaryWallet.address.substring(0, 7)}...{primaryWallet.address.slice(-5)}
                  </SupText>
                )}
              </SupButton>
            </div>
            {user ? (
              <SupChip active icon={<SupCheckCircle className="h-6 w-6" />} label="Authenticated" small variant="success" />
            ) : (
              <SupButton
                variant="outlined"
                className="h-8 px-1.5 py-3 hover:bg-success-200"
                color="success"
                disabled={isAuthenticating}
                prefixIcon={isAuthenticating ? <SupLoader isSmall /> : <SupLock className="h-5 w-5" />}
                onClick={authenticateUser}
              >
                Authenticate
              </SupButton>
            )}
          </div>
          <button onClick={disconnectWallet}>
            <MenuItem icon={<SupWalletDisconnect className="size-6" />} title="Disconnect" />
          </button>
        </Fragment>
      )}
    </nav>
  );
}
